import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { OnlyData } from '@/utils/subtypes'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'

export default interface ISceneModel {
    scene: THREE.Scene
    camera: THREE.PerspectiveCamera
    renderer: THREE.WebGLRenderer
    fxaaPass: ShaderPass | null
    fisheyePass: ShaderPass | null
    gammaCorrectionPass: ShaderPass | null
    composer: EffectComposer | null
    controls: OrbitControls
    canvas: HTMLCanvasElement
    sceneContainer: HTMLCanvasElement
    maxAnisotropy: number
    postprocessing: boolean
}

export class SceneModel implements ISceneModel {
    scene!: THREE.Scene
    camera!: THREE.PerspectiveCamera
    renderer!: THREE.WebGLRenderer
    composer!: EffectComposer | null
    fxaaPass!: ShaderPass | null
    fisheyePass!: ShaderPass | null
    gammaCorrectionPass!: ShaderPass | null
    controls!: OrbitControls
    canvas!: HTMLCanvasElement
    sceneContainer!: HTMLCanvasElement
    maxAnisotropy!: number
    postprocessing!: boolean

    constructor(data: OnlyData<SceneModel>) {
        Object.assign(this, data);
    }
}

